import { Injectable } from '@angular/core';
import { isFalsy } from '@shared/helpers';

@Injectable({ providedIn: 'root' })
export class Logger {
  public logObjectKeys<T extends object>(object: T): void {
    Object.keys(object).forEach((key) => console.log(`Object key: ${key}.`));
  }
  public logArrayItems<T extends any[]>(array: T): void {
    array.forEach((item, index) => console.log(`Array item at [${index}] : ${item}.`));
  }

  public logIfFalsy(element: any, context: string): void {
    if (isFalsy(element)) console.log(`[${context}] element is falsy. Retrieved type : ${typeof element}`);
  }
  public logIfNotFound(methodToFind: string, context: string): void {
    console.log(`[${context}] Element does not exist or not found. Method used : ${methodToFind}`);
  }

  public log(element: unknown, context: string): void {
    console.log(`[${context}]`, element);
  }
}
